import { 
    adicionar as adicionaDenuncia,
    atualizar as atualizaDenuncia,  
    obterPorProtocolo as obtemDenuncia,
    obterTodasComStatusCadastrada as obtemTodasComStatusCadastrada 
} from '../api/DenunciaApi'
import { adicionar as adicionaComplemento } from '../api/ComplementoApi'
import { adicionar as adicionaFotocopia, obter as obtemFotocopia } from '../api/FotocopiaApi'
import { obterPorProtocolo as obtemComplementosPorProtocolo } from '../api/ComplementoApi'

export const obterPorProtocolo = protocolo => {

    return new Promise((resolve,reject) => {
        let pacote = {}
        obtemDenuncia(protocolo)
        .then( denuncia => {
            pacote.denuncia = denuncia
            obterComplementos(pacote.denuncia)
            .then( complementos => {
                pacote.complementos = complementos
                resolve(pacote)
            })
            .catch( erroComplementos => {
                reject(erroComplementos)
            })
        })
        .catch( erroDenuncia => {
            reject(erroDenuncia)
        })
    })
} 

export const obterTodasComStatusCadastrada = () => {

    return new Promise((resolve,reject) => {

        let pacote = {}
        obtemTodasComStatusCadastrada()
        .then( denuncias => {
            pacote.denuncias = denuncias
            if (pacote.denuncias.length === 0) {
                reject({ 
                    tipo:"problema", 
                    texto:"Não existem denúncias cadastradas. O banco de dados se encontra vazio!"
                })
                return
            }

            for (let i=0; i<pacote.denuncias.length; i++) {
                obterComplementos(pacote.denuncias[i])
                .then( complementos => {
                    pacote.denuncias[i].complementos = complementos
                    if (i === (pacote.denuncias.length - 1)) {
                        resolve(pacote.denuncias)
                    }
                })
                .catch( erroComplementos => {
                    reject(erroComplementos)
                })
            }
        })
        .catch( erroDenuncia => {
            reject(erroDenuncia)
        })
    })
} 

export const adicionarDenuncia = (denuncia,fotocopias) => {

    return new Promise((resolve,reject) => {

        adicionarFotocopias("D",denuncia.protocolo,fotocopias)
        .then( idsFotocopias => {
            denuncia.idsFotocopias = idsFotocopias
            denuncia.idsComplementos = []
            adicionaDenuncia(denuncia)
            .then( resposta => {
                resolve(resposta)
            })
            .catch( erroRespDenuncia => {
                reject(erroRespDenuncia)
            })
        })
    })
} 

export const adicionarComplemento = (complemento,fotocopias) => {

    return new Promise((resolve,reject) => {
        adicionarFotocopias("C",complemento.protocolo,fotocopias)
        .then( idsFotocopias => {
            complemento.idsFotocopias = idsFotocopias
            adicionaComplemento(complemento)
            .then( complementoNovo => {
                atualizarDenuncia(complemento.protocolo,complementoNovo._id)
                .then( denunciaAtualizada => {
                    resolve(denunciaAtualizada)
                })
                .catch( erroAtualizarDenuncia => {
                    reject(erroAtualizarDenuncia)
                })
            })
            .catch( erroAdicionaComplemento => {
                reject(erroAdicionaComplemento)
            })
        })
    })
}

export const obterFotocopias = idsFotocopias => {

    return new Promise((resolve,reject) => {

        let fotocopias = []
        if (idsFotocopias.length == 0) {
            resolve(fotocopias)
        }
        
        let idFotocopia = null
        for (let i=0; i<idsFotocopias.length; i++) {
            idFotocopia = idsFotocopias[i];
            obtemFotocopia(idFotocopia)
            .then( fotocopia => {
                fotocopias.push(fotocopia)
                if (i === (idsFotocopias.length - 1)) {
                    resolve(fotocopias)
                }
            })
            .catch( erroFotocopia => {
                reject(erroFotocopia)
            })
        }
    })
}

export const obterComplementos = denuncia => {
    return new Promise((resolve,reject) => {
        if (denuncia.idsComplementos.length === 0) {
            resolve([])
        }

        obtemComplementosPorProtocolo(denuncia.protocolo)
        .then( complementos => {
            resolve(complementos)
        })
        .catch( erroComplemento => {
            reject(erroComplemento)
        })
    })
}

const adicionarFotocopias = (prefixo,protocolo,fotocopias) => {

    return new Promise((resolve,reject) => {
        let idsFotocopias = []
        if (fotocopias.length === 0) {
            resolve(idsFotocopias)
        }
        let fotocopia = null
        for (let i=0; i<fotocopias.length; i++) {
            fotocopia = fotocopias[i]
            adicionaFotocopia({ 
                prefixo,
                protocolo,
                contentType:fotocopia.contentType,
                fileName:fotocopia.fileName,
                data:fotocopia.data,
            })
            .then( resposta => {
                const fotocopiaNova = resposta
                idsFotocopias.push(fotocopiaNova._id)
                if (i === (fotocopias.length - 1)) {
                    resolve(idsFotocopias)
                }
            })
            .catch( erroFotocopias => {
                reject(erroFotocopias)
            })
        }
    })
}

const atualizarDenuncia = (protocolo,idComplemento) => {

    return new Promise((resolve,reject) => {
        obtemDenuncia(protocolo)
        .then( denunciaLida => {
            denunciaLida.idsComplementos.push(idComplemento)
            atualizaDenuncia(denunciaLida)
            .then( denunciaAtualizada => {
                resolve(denunciaAtualizada)
            })
            .catch( erroDenunciaAtualizada => {
                reject(erroDenunciaAtualizada)
            })
        })
        .catch( erroDenunciaLida => {
            reject(erroDenunciaLida)
        })
    })
}

export const obterProvidencias = denuncia => {

    return new Promise((resolve,reject) => {
        let complementos = []
        if (denuncia.idsComplementos.length === 0) {
            resolve(complementos) 
        }

        let idComplemento = null
        for (let i=0; i<denuncia.idsComplementos.length; i++) {
            idComplemento = denuncia.idsComplementos[i]
            obtemComplemento(idComplemento)
            .then( complemento => {
                if (complemento.status) {
                    if (complemento.status === 'PROVIDENCIA') {
                        complementos.push(complemento)
                    }
                }
                if (i === (denuncia.idsComplementos.length - 1)) {
                    resolve(complementos)
                }
            })
            .catch( erroComplemento => {
                reject(erroComplemento)
            })
        }
    })
}